import { BaseModel } from "./baseModel";

export class LineLotSummaryModel extends BaseModel {
    public lotId:number;
    public lineId:number;
    public refNum:string;
    public clipReference:string;
    public description:string;
    public binCode:string;
    public noBales:number;
    public weight:number;
    public traceabilityStatus:string;
    public micron:number;
    public length:number;
    public strength:number;
}